import gql from 'graphql-tag';

export default gql`
  query ($subjectId: MongoID!, $studentId: MongoID!) {
    subjectProgress(subjectId: $subjectId, studentId: $studentId) {
      subjectId
      studentId
      totalContents
      completedContents
      progressPercent
      contentProgresses {
        contentId
        contentName
        contentType
        progress
        zoomprogress
        certificateProgress
      }
    }
  }
`;
